/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type CartRightNavComponent_viewer$ref = any;
export type CartRightNavComponentQueryVariables = {};
export type CartRightNavComponentQueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": CartRightNavComponent_viewer$ref;
    }) | null;
};
export type CartRightNavComponentQuery = {
    readonly response: CartRightNavComponentQueryResponse;
    readonly variables: CartRightNavComponentQueryVariables;
};



/*
query CartRightNavComponentQuery {
  viewer {
    id
    ...CartRightNavComponent_viewer
  }
}

fragment CartRightNavComponent_viewer on Viewer {
  id
  productsBulk(first: 2, productIds: ["4f3661e6-9d11-43bc-872e-6f4cc1df744f", "7e86bc10-4203-4078-a006-ba8394422f20"]) {
    edges {
      node {
        id
        productId
        price
        priceSale
        images {
          id
          productCatalog
          squareFront
        }
        productPermissions {
          oneCommerce {
            preferredCustomer {
              add
            }
          }
        }
      }
    }
  }
  user {
    id
    role
    userId
    email
    firstName
    pointBalance
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
        preferredCustomer {
          access
        }
      }
    }
    conciergeCustomerAccountId
    conciergeUser {
      firstName
      lastName
      userId
      pointBalance
      permissions {
        id
        oneCommerce {
          id
          ceo {
            access
          }
          preferredCustomer {
            access
          }
        }
      }
      id
    }
    shoppingWithCeoUser {
      id
      userId
    }
    cartV2 {
      id
      cartId
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      bottleDiscount4
      bottleDiscount6
      bottleDiscount12
      promoCodeSavings
      saleSavings
      canSubscribeForAutoShip
      discountQualifiedCartTotal
      subTotalPriceOfItems
      subTotalPriceOfItemsWithDiscount
      total
      totalSavings
      totalNumberOfItems
      eventId
      eventHostFirstName
      event {
        id
        eventId
        trinityPartyType
      }
      promoCodes {
        id
        code
        promoDescription
        thresholds {
          discountAmount
          discountAmountEach
        }
      }
      wordPressCoupons {
        code
        couponDescription
        storeBalance
        yotpoCouponCode
        id
      }
      wordPressCouponSavings
      entries(first: 1000) {
        edges {
          node {
            id
            sku
            productId
            quantity
            productName
            productURLslug
            productImageUrl
            wineBottleQuantity
            isWinePack
            priceOriginal
            priceSale
            priceDiscount
            discountEligible
            priceDiscountPercent
            hasQualifyingDiscount
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pointBalance",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v7 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "permissions",
        "storageKey": null,
        "args": null,
        "concreteType": "PermissionsType",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "OneCommerceType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "ceo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": (v6 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": (v6 /*: any*/)
                    }
                ]
            }
        ]
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartRightNavComponentQuery",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "CartRightNavComponent_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartRightNavComponentQuery",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "productsBulk",
                            "storageKey": "productsBulk(first:2,productIds:[\"4f3661e6-9d11-43bc-872e-6f4cc1df744f\",\"7e86bc10-4203-4078-a006-ba8394422f20\"])",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2,
                                    "type": "Int"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "productIds",
                                    "value": [
                                        "4f3661e6-9d11-43bc-872e-6f4cc1df744f",
                                        "7e86bc10-4203-4078-a006-ba8394422f20"
                                    ],
                                    "type": "[String]"
                                }
                            ],
                            "concreteType": "ProductConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "price",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "images",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Images",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCatalog",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "squareFront",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "productPermissions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductPermissions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "oneCommerce",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AppProductPermissionsAccess",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "preferredCustomer",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "add",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v0 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v5 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v7 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "conciergeCustomerAccountId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "lastName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/),
                                        (v3 /*: any*/),
                                        (v7 /*: any*/),
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v4 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cartV2",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CartV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v0 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipEnabled",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipIntervalUnit",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipIntervalCount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "bottleDiscount4",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "bottleDiscount6",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "bottleDiscount12",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "promoCodeSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "saleSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canSubscribeForAutoShip",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "discountQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "cartId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItemsWithDiscount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "total",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v8 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventHostFirstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "trinityPartyType",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "promoCodes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCode",
                                            "plural": true,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "promoDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "thresholds",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PromoCodeThresholds",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "discountAmount",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "discountAmountEach",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "wordPressCoupons",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "WordPressCoupon",
                                            "plural": true,
                                            "selections": [
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "couponDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "storeBalance",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "yotpoCouponCode",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v0 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "wordPressCouponSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000,
                                                    "type": "Int"
                                                }
                                            ],
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "wineBottleQuantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/),
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "quantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productURLslug",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productImageUrl",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "sku",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "isWinePack",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceOriginal",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "discountEligible",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscountPercent",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hasQualifyingDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "CartRightNavComponentQuery",
            "id": null,
            "text": "query CartRightNavComponentQuery {\n  viewer {\n    id\n    ...CartRightNavComponent_viewer\n  }\n}\n\nfragment CartRightNavComponent_viewer on Viewer {\n  id\n  productsBulk(first: 2, productIds: [\"4f3661e6-9d11-43bc-872e-6f4cc1df744f\", \"7e86bc10-4203-4078-a006-ba8394422f20\"]) {\n    edges {\n      node {\n        id\n        productId\n        price\n        priceSale\n        images {\n          id\n          productCatalog\n          squareFront\n        }\n        productPermissions {\n          oneCommerce {\n            preferredCustomer {\n              add\n            }\n          }\n        }\n      }\n    }\n  }\n  user {\n    id\n    role\n    userId\n    email\n    firstName\n    pointBalance\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    conciergeCustomerAccountId\n    conciergeUser {\n      firstName\n      lastName\n      userId\n      pointBalance\n      permissions {\n        id\n        oneCommerce {\n          id\n          ceo {\n            access\n          }\n          preferredCustomer {\n            access\n          }\n        }\n      }\n      id\n    }\n    shoppingWithCeoUser {\n      id\n      userId\n    }\n    cartV2 {\n      id\n      cartId\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      bottleDiscount4\n      bottleDiscount6\n      bottleDiscount12\n      promoCodeSavings\n      saleSavings\n      canSubscribeForAutoShip\n      discountQualifiedCartTotal\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithDiscount\n      total\n      totalSavings\n      totalNumberOfItems\n      eventId\n      eventHostFirstName\n      event {\n        id\n        eventId\n        trinityPartyType\n      }\n      promoCodes {\n        id\n        code\n        promoDescription\n        thresholds {\n          discountAmount\n          discountAmountEach\n        }\n      }\n      wordPressCoupons {\n        code\n        couponDescription\n        storeBalance\n        yotpoCouponCode\n        id\n      }\n      wordPressCouponSavings\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            sku\n            productId\n            quantity\n            productName\n            productURLslug\n            productImageUrl\n            wineBottleQuantity\n            isWinePack\n            priceOriginal\n            priceSale\n            priceDiscount\n            discountEligible\n            priceDiscountPercent\n            hasQualifyingDiscount\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b8d58373f17ec68ce8e787f1d636ccdd';
export default node;
